/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { useLocation } from "react-router";
import { NavLink } from "react-router-dom";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl, checkIsActive } from "../../../../_helpers";

export function AsideMenuList({ layoutProps }) {
  const location = useLocation();
  const getMenuItemActive = (url, hasSubmenu = false) => {
    return checkIsActive(location, url)
      ? ` ${!hasSubmenu && "menu-item-active"} menu-item-open `
      : "";
  };

  return (
    <>

      <ul className={`menu-nav ${layoutProps.ulClasses}`}>


       {/* KYC Link */}
       <li
          className={`menu-item ${getMenuItemActive("/kyc", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/kyc">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/menu/13.svg")} />
            </span>
            <span className="menu-text">KYC</span>
          </NavLink>
        </li>



        <li
          className={`menu-item ${getMenuItemActive("/dashboard", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/dashboard">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/menu/11.svg")} />
            </span>
            <span className="menu-text">My Account</span>
          </NavLink>
        </li>

        {/* Disabled Tab */}
        {/* <li
          className={`menu-item ${getMenuItemActive("/contract-market", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/dashboard/contract-market">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/menu/11.svg")} />
            </span>
            <span className="menu-text">Gold Market</span>
          </NavLink>
        </li> */}
        
        <li
          className={`menu-item ${getMenuItemActive("/order-list", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/order-list">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/menu/12.svg")} />
            </span>
            <span className="menu-text">Order List</span>
          </NavLink>
        </li>
        <li
          className={`menu-item ${getMenuItemActive("/activity", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/activity">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/menu/14.svg")} />
            </span>
            <span className="menu-text">Activity</span>
          </NavLink>
        </li>
        <li
          className={`menu-item ${getMenuItemActive("/withdrawal", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/withdrawal">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/menu/13.svg")} />
            </span>
            <span className="menu-text">Withdrawal</span>
          </NavLink>
        </li>



        <li
          className={`menu-item ${getMenuItemActive("/support", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/support">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/menu/7.svg")} />
            </span>
            <span className="menu-text">Support</span>
          </NavLink>
        </li>
      </ul>

      {/* end::Menu Nav */}
    </>
  );
}
